"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.renderOneTrust = renderOneTrust;
exports.renderThirdPartyScripts = renderThirdPartyScripts;
var _config = require("@ori-appshell/config");
var _jsxRuntime = require("react/jsx-runtime");
function getGoogleAnalyticsModel(gtmConfiguration) {
  return {
    GtmId: gtmConfiguration?.gtmId
  };
}
/**
 * Check if you are on local domain for example - uk.online.ori
 * Used to not load OneTrust on local domains
 */
// const isLocalDomain = (hostname?: string): boolean => {
//   if (!hostname) {
//     return false;
//   }

//   return hostname.endsWith('.ori');
// };

function renderGoogleAnalytics({
  gtmConfiguration,
  clientAppsUrl,
  environment
}) {
  if (!gtmConfiguration?.gtmId) {
    return null;
  }
  const model = getGoogleAnalyticsModel(gtmConfiguration);
  const encodedModel = JSON.stringify(model);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("script", {
      id: "analytics-provider-data",
      type: "application/json",
      crossOrigin: "anonymous"
      // eslint-disable-next-line react/no-danger -- we don't want the encoded model escaped
      ,
      dangerouslySetInnerHTML: {
        __html: encodedModel
      }
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("script", {
      defer: true,
      crossOrigin: "anonymous",
      src: (0, _config.createSpaEntryfileUrl)('analytics-provider', environment, clientAppsUrl)
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("noscript", {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("iframe", {
        title: "gtm",
        src: `//www.googletagmanager.com/ns.html?id=${gtmConfiguration.gtmId}`,
        height: "0",
        width: "0"
      })
    })]
  });
}
function renderOneTrust(oneTrustConfiguration) {
  // TODO (OL): Commented out because of incorrect check of current request basename. Window is not available in this function at all
  // if (!oneTrustConfiguration?.scriptId || isLocalDomain(window.location.hostname)) {
  //   return null;
  // }
  if (!oneTrustConfiguration?.scriptId) {
    return null;
  }

  // TODO cookie handling
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [oneTrustConfiguration.autoBlockScriptId ? /*#__PURE__*/(0, _jsxRuntime.jsx)("script", {
      defer: true,
      type: "text/javascript",
      src: `https://cdn.cookielaw.org/consent/${oneTrustConfiguration.autoBlockScriptId}/OtAutoBlock.js`
    }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)("script", {
      defer: true,
      crossOrigin: "anonymous",
      src: "https://cdn.cookielaw.org/scripttemplates/otSDKStub.js",
      type: "text/javascript"
      // eslint-disable-next-line unicorn/text-encoding-identifier-case -- Parameter for 3rd party API
      ,
      charSet: "UTF-8",
      "data-document-language": "true",
      "data-domain-script": oneTrustConfiguration.scriptId
    })]
  });
}
function renderThirdPartyScripts({
  thirdPartyConfiguration,
  clientAppsUrl,
  environment
}) {
  if (!thirdPartyConfiguration) {
    return null;
  }
  return renderGoogleAnalytics({
    gtmConfiguration: thirdPartyConfiguration.gtm,
    clientAppsUrl,
    environment
  });
}
